<div class="layout-topbar">
  <div class="layout-topbar-logo-container">
    <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
      <i class="pi pi-bars"></i>
    </button>
    <a class="layout-topbar-logo" routerLink="/">
      @if (!isDarkMode()) {
        <img src="BPV-Icon-Black-Small_v3.png" alt="logo" />
      }
      @if (isDarkMode()) {
        <img src="BPV-Icon-White-Small_v3.png" alt="logo" />
      }
    </a>
  </div>
  <div class="layout-topbar-title">
    <a routerLink="/">Bremspunkt Verweigerer</a>
  </div>

  <div class="layout-topbar-actions">
    <div class="layout-config-menu">
      <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
        <i [ngClass]="{ 'pi ': true, 'pi-moon': layoutService.isDarkTheme(), 'pi-sun': !layoutService.isDarkTheme() }"></i>
      </button>
      <div class="relative">
        <app-configurator />
      </div>
    </div>

    <button class="layout-topbar-menu-button layout-topbar-action" pStyleClass="@next" enterFromClass="hidden" enterActiveClass="animate-scalein" leaveToClass="hidden" leaveActiveClass="animate-fadeout" [hideOnOutsideClick]="true">
      <i class="pi pi-ellipsis-v"></i>
    </button>

    <div class="layout-topbar-menu hidden lg:block">
      <div class="layout-topbar-menu-content">
        <button type="button" class="layout-topbar-action" (click)="openDiscord()">
          <i class="pi pi-discord"></i>
          <span>Discord</span>
        </button>
        <button type="button" class="layout-topbar-action" (click)="openFacebook()">
          <i class="pi pi-facebook"></i>
          <span>Facebook</span>
        </button>
      </div>
    </div>
  </div>
</div>